import React, { Component } from 'react';
import { Header } from '../../components/index';
import {
  Heading2,
  Text,
  Heading3,
  List,
  ListItem,
} from '../../helper/Typography';
import { Container } from '../imprint/imprint';
import { SeoDataComponent } from '@lws/react-components';
import { mapMetaObject } from '../../helper/helperServices';

interface EntryPageProps {
  pageContext: {
    generalTexts: any;
    routeTexts: any;
    locale: string;
    id: string;
  };
}

class DataProtection extends Component<EntryPageProps> {
  render() {
    const {
      generalTexts,
      routeTexts: dataProtection,
      locale,
    } = this.props.pageContext;
    return (
      <main className={'App Light'}>
        <SeoDataComponent data={mapMetaObject(dataProtection.meta).data} />
        <Header
          darkTheme={false}
          lang={locale}
          pathname={this.props.location.pathname}
          generalTexts={generalTexts}
        />
        <Container>{locale === 'de' ? <De /> : <En />}</Container>
      </main>
    );
  }
}
const En = () => (
  <>
    <Heading2>Data Protection</Heading2>
    <Heading2 style={{ marginTop: '48px', fontSize: '32px' }}>
      1. Introduction
    </Heading2>
    <Text.p>
      In the following, we provide information about the collection of personal
      data when using our website www.neugelb.com and our profiles in social
      media. Personal data is any data that can be related to a specific natural
      person, such as their name or IP address.
    </Text.p>

    <Heading3>1.1 Contact details</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      The controller within the meaning of Art. 4 para. 7 EU General Data
      Protection Regulation (GDPR) is: <br />
      NEUGELB Studios GmbH <br />
      Zeughofstraße 20, Berlin, Germany
      <br /> E-Mail:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="mailto:intern@neugelb.com"
        aria-label="Email Neugelb Studios"
      >
        intern@neugelb.com
      </a>
      <br />
      We are legally represented by Thomas Kaiser
      <br />
      Vorsitzender des Verwaltungsrats: Dominik Stöttner
    </Text.p>
    <Text.p>
      Our data protection officer can be reached via:
      <br /> heyData GmbH
      <br />
      Schützenstraße 5, 10117 Berlin <br />
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.heydata.eu"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="heyData website"
      >
        www.heydata.eu
      </a>
      <br />
      E-Mail:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="mailto:datenschutz@heydata.eu"
        aria-label="Email data protection officer"
      >
        datenschutz@heydata.eu
      </a>
    </Text.p>

    <Heading3>
      1.2 Scope of data processing, processing purposes and legal bases
    </Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      We detail the scope of data processing, processing purposes and legal
      bases below. In principle, the following come into consideration as the
      legal basis for data processing:
    </Text.p>
    <div style={{ marginLeft: '20px' }}>
      <List>
        <ListItem style={{ marginBottom: '16px' }}>
          Art. 6 para. 1 s. 1 lit. a GDPR serves as our legal basis for
          processing operations for which we obtain consent.
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Art. 6 para. 1 s. 1 lit. b GDPR is the legal basis insofar as the
          processing of personal data is necessary for the performance of a
          contract, e.g. if a site visitor purchases a product from us or we
          perform a service for him. This legal basis also applies to processing
          that is necessary for pre-contractual measures, such as in the case of
          inquiries about our products or services.
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Art. 6 para. 1 s. 1 lit. c GDPR applies if we fulfill a legal
          obligation by processing personal data, as may be the case, for
          example, in tax law.
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Art. 6 para. 1 s. 1 lit. f GDPR serves as the legal basis when we can
          rely on legitimate interests to process personal data, e.g. for
          cookies that are necessary for the technical operation of our website.
        </ListItem>
      </List>
    </div>

    <Heading3>1.3 Data processing outside the EEA</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Insofar as we transfer data to service providers or other third parties
      outside the EEA, the security of the data during the transfer is
      guaranteed by adequacy decisions of the EU Commission, insofar as they
      exist (e.g. for Great Britain, Canada and Israel) (Art. 45 para. 3 GDPR).
    </Text.p>
    <Text.p>
      In the case of data transfer to service providers in the USA, the legal
      basis for the data transfer is an adequacy decision of the EU Commission
      if the service provider has also certified itself under the EU US Data
      Privacy Framework.
    </Text.p>
    <Text.p>
      In other cases (e.g. if no adequacy decision exists), the legal basis for
      the data transfer are usually, i.e. unless we indicate otherwise, standard
      contractual clauses. These are a set of rules adopted by the EU Commission
      and are part of the contract with the respective third party. According to
      Art. 46 para. 2 lit. b GDPR, they ensure the security of the data
      transfer. Many of the providers have given contractual guarantees that go
      beyond the standard contractual clauses to protect the data. These
      include, for example, guarantees regarding the encryption of data or
      regarding an obligation on the part of the third party to notify data
      subjects if law enforcement agencies wish to access the respective data.
    </Text.p>

    <Heading3>1.4 Storage duration</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Unless expressly stated in this privacy policy, the data stored by us will
      be deleted as soon as they are no longer required for their intended
      purpose and no legal obligations to retain data conflict with the
      deletion. If the data are not deleted because they are required for other
      and legally permissible purposes, their processing is restricted, i.e. the
      data are blocked and not processed for other purposes. This applies, for
      example, to data that must be retained for commercial or tax law reasons.
    </Text.p>

    <Heading3>1.5 Rights of data subjects</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Data subjects have the following rights against us with regard to their
      personal data:
    </Text.p>
    <div style={{ marginLeft: '20px' }}>
      <List>
        <ListItem style={{ marginBottom: '16px' }}>Right of access</ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Right to correction or deletion
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Right to limit processing
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Right to object to the processing
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Right to data transferability
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Right to revoke a given consent at any time
        </ListItem>
      </List>
    </div>
    <Text.p>
      Data subjects also have the right to complain to a data protection
      supervisory authority about the processing of their personal data. Contact
      details of the data protection supervisory authorities are available at{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.bfdi.bund.de/EN/Service/Anschriften/Laender/Laender-node.html"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Data protection supervisory authorities"
      >
        https://www.bfdi.bund.de/EN/Service/Anschriften/Laender/Laender-node.html
      </a>
      .
    </Text.p>

    <Heading3>1.6 Obligation to provide data</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Within the scope of the business or other relationship, customers,
      prospective customers or third parties need to provide us with personal
      data that is necessary for the establishment, execution and termination of
      a business or other relationship or that we are legally obliged to
      collect. Without this data, we will generally have to refuse to conclude
      the contract or to provide a service or will no longer be able to perform
      an existing contract or other relationship.
    </Text.p>
    <Text.p>Mandatory data are marked as such.</Text.p>

    <Heading3>1.7 No automatic decision making in individual cases</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      As a matter of principle, we do not use a fully automated decision-making
      process in accordance with article 22 GDPR to establish and implement the
      business or other relationship. Should we use these procedures in
      individual cases, we will inform of this separately if this is required by
      law.
    </Text.p>

    <Heading3>1.8 Making contact</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      When contacting us, e.g. by e-mail or telephone, the data provided to us
      (e.g. names and e-mail addresses) will be stored by us in order to answer
      questions. The legal basis for the processing is our legitimate interest
      (Art. 6 para. 1 s. 1 lit. f GDPR) to answer inquiries directed to us. We
      delete the data accruing in this context after the storage is no longer
      necessary or restrict the processing if there are legal retention
      obligations.
    </Text.p>

    <Heading3>1.9 Customer surveys</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      From time to time, we conduct customer surveys to get to know our
      customers and their wishes better. In doing so, we collect the data
      requested in each case. It is our legitimate interest to get to know our
      customers and their wishes better, so that the legal basis for the
      associated data processing is Art. 6 para. 1 s. 1 lit f GDPR. We delete
      the data when the results of the surveys have been evaluated.
    </Text.p>

    <Heading2 style={{ marginTop: '48px', fontSize: '32px' }}>
      2. Data processing on our website
    </Heading2>

    <Heading3>2.1 Notice for website visitors from Germany</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Our website stores information in the terminal equipment of website
      visitors (e.g. cookies) or accesses information that is already stored in
      the terminal equipment (e.g. IP addresses). What information this is in
      detail can be found in the following sections.
    </Text.p>
    <Text.p>
      This storage and access is based on the following provisions:
    </Text.p>
    <div style={{ marginLeft: '20px' }}>
      <List>
        <ListItem style={{ marginBottom: '16px' }}>
          Insofar as this storage or access is absolutely necessary for us to
          provide the service of our website expressly requested by website
          visitors (e.g., to carry out a chatbot used by the website visitor or
          to ensure the IT security of our website), it is carried out on the
          basis of Section 25 para. 2 no. 2 of the German Telecommunications
          Digital Services Data Protection Act
          (Telekommunikation-Digitale-Dienste-Datenschutzgesetz, "TDDDG").
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Otherwise, this storage or access takes place on the basis of the
          website visitor's consent (Section 25 para. 1 TDDDG).
        </ListItem>
      </List>
    </div>
    <Text.p>
      The subsequent data processing is carried out in accordance with the
      following sections and on the basis of the provisions of the GDPR.
    </Text.p>

    <Heading3>2.2 Informative use of our website</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      During the informative use of the website, i.e. when site visitors do not
      separately transmit information to us, we collect the personal data that
      the browser transmits to our server in order to ensure the stability and
      security of our website. This is our legitimate interest, so that the
      legal basis is Art. 6 para. 1 s. 1 lit. f GDPR.
    </Text.p>
    <Text.p>These data are:</Text.p>
    <div style={{ marginLeft: '20px' }}>
      <List>
        <ListItem style={{ marginBottom: '16px' }}>IP address</ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Date and time of the request
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Time zone difference to Greenwich Mean Time (GMT)
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Content of the request (specific page)
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Access status/HTTP status code
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Amount of data transferred in each case
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Website from which the request comes
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>Browser</ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Operating system and its interface
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Language and version of the browser software
        </ListItem>
      </List>
    </div>
    <Text.p>
      This data is also stored in log files. They are deleted when their storage
      is no longer necessary, at the latest after 14 days.
    </Text.p>

    <Heading3>2.3 Web hosting and provision of the website</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Our website is hosted by Microsoft Azure. The provider is Microsoft
      Ireland Operations Limited, One Microsoft Place, South County Business
      Park, Leopardstown, Dublin 18, D18 P521, Ireland. In doing so, the
      provider processes the personal data transmitted via the website, e.g.
      content, usage, meta/communication data or contact data, in the EU.
      Further information can be found in the provider's privacy policy at{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://privacy.microsoft.com/en-gb/privacystatement"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Microsoft privacy statement"
      >
        https://privacy.microsoft.com/en-gb/privacystatement
      </a>
      .
    </Text.p>
    <Text.p>
      It is our legitimate interest to provide a website, so the legal basis of
      the described data processing is Art. 6 para. 1 s. 1 lit. f GDPR.
    </Text.p>

    <Heading3>2.4 Contact form</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      When contacting us via the contact form on our website, we store the data
      requested there and the content of the message. The legal basis for the
      processing is our legitimate interest in answering inquiries directed to
      us. The legal basis for the processing is therefore Art. 6 para. 1 s. 1
      lit. f GDPR. We delete the data accruing in this context after the storage
      is no longer necessary or restrict the processing if there are legal
      retention obligations.
    </Text.p>

    <Heading3>2.5 Vacant positions</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      We publish vacant positions on our website, on pages linked to the website
      or on third-party websites.
    </Text.p>
    <Text.p>
      The processing of the data provided as part of the application is carried
      out for the purpose of implementing the application process. Insofar as
      this is necessary for our decision to establish an employment
      relationship, the legal basis is Art. 88 para. GDPR in conjunction with
      Sec. 26 para. 1 of the German Data Protection Act
      (Bundesdatenschutzgesetz). We have marked the data required to carry out
      the application process accordingly or refer to them. If applicants do not
      provide this data, we cannot process the application. Further data is
      voluntary and not required for an application. If applicants provide
      further information, the basis is their consent (Art. 6 para. 1 s. 1 lit.
      a GDPR).
    </Text.p>
    <Text.p>
      We ask applicants to refrain from providing information on political
      opinions, religious beliefs and similarly sensitive data in their CV and
      cover letter. They are not required for an application. If applicants
      nevertheless provide such information, we cannot prevent their processing
      as part of the processing of the resume or cover letter. Their processing
      is then also based on the consent of the applicants (Art. 9 para. 2 lit. a
      GDPR).
    </Text.p>
    <Text.p>
      Finally, we process the applicants' data for further application
      procedures if they have given us their consent to do so. In this case, the
      legal basis is Art. 6 para. 1 s. 1 lit. a GDPR.
    </Text.p>
    <Text.p>
      We pass on the applicants' data to the responsible employees in the HR
      department, to our data processors in the area of recruiting and to the
      employees otherwise involved in the application process.
    </Text.p>
    <Text.p>
      If we enter into an employment relationship with the applicant following
      the application process, we delete the data only after the employment
      relationship has ended. Otherwise, we delete the data no later than six
      months after rejecting an applicant.
    </Text.p>
    <Text.p>
      If applicants have given us their consent to use their data for further
      application procedures as well, we will not delete their data until one
      year after receiving the application.
    </Text.p>

    <Heading3>2.6 Third parties</Heading3>

    <Heading3 style={{ marginTop: '24px', fontSize: '22px' }}>
      2.6.1 heyData
    </Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      We have integrated a data protection seal on our website. The provider is
      heyData GmbH, Schützenstraße 5, 10117 Berlin, Germany. The provider
      processes meta/communication data (e.g. IP addresses) in the EU.
    </Text.p>
    <Text.p>
      The legal basis of the processing is Art. 6 para. 1 s. 1 lit. f GDPR. We
      have a legitimate interest in providing website visitors with confirmation
      of our data privacy compliance. At the same time, the provider has a
      legitimate interest in ensuring that only customers with existing
      contracts use its seals, which is why a mere image copy of the certificate
      is not a viable alternative as confirmation.
    </Text.p>
    <Text.p>
      As the data is masked after collection, there is no possibility to
      identify website visitors. Further information is available in the privacy
      policy of the provider at{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://heydata.eu/en/privacy-policy"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="heyData privacy policy"
      >
        https://heydata.eu/en/privacy-policy
      </a>
      .
    </Text.p>

    <Heading2 style={{ marginTop: '48px', fontSize: '32px' }}>
      3. Data processing on social media platforms
    </Heading2>
    <Text.p style={{ marginTop: '24px' }}>
      We are represented in social media networks in order to present our
      organization and our services there. The operators of these networks
      regularly process their users' data for advertising purposes. Among other
      things, they create user profiles from their online behavior, which are
      used, for example, to show advertising on the pages of the networks and
      elsewhere on the Internet that corresponds to the interests of the users.
      To this end, the operators of the networks store information on user
      behavior in cookies on the users' computers. Furthermore, it cannot be
      ruled out that the operators merge this information with other data. Users
      can obtain further information and instructions on how to object to
      processing by the site operators in the data protection declarations of
      the respective operators listed below. It is also possible that the
      operators or their servers are located in non-EU countries, so that they
      process data there. This may result in risks for users, e.g. because it is
      more difficult to enforce their rights or because government agencies
      access the data.
    </Text.p>
    <Text.p>
      If users of the networks contact us via our profiles, we process the data
      provided to us in order to respond to the inquiries. This is our
      legitimate interest, so that the legal basis is Art. 6 para. 1 s. 1 lit. f
      GDPR.
    </Text.p>

    <Heading3>3.1 Facebook</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      We maintain a profile on Facebook. The operator is Meta Platforms Ireland
      Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland. The
      privacy policy is available here:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.facebook.com/policy.php"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Facebook privacy policy"
      >
        https://www.facebook.com/policy.php
      </a>
      . A possibility to object to data processing arises via settings for
      advertisements:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.facebook.com/settings?tab=ads"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Facebook advertisement settings"
      >
        https://www.facebook.com/settings?tab=ads
      </a>
      .
    </Text.p>
    <Text.p>
      We are joint controllers for processing the data of visitors to our
      profile on the basis of an agreement within the meaning of Art. 26 GDPR
      with Facebook. Facebook explains exactly what data is processed at{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.facebook.com/legal/terms/information_about_page_insights_data"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Facebook page insights data information"
      >
        https://www.facebook.com/legal/terms/information_about_page_insights_data
      </a>
      . Data subjects can exercise their rights both against us and against
      Facebook. However, according to our agreement with Facebook, we are
      obliged to forward requests to Facebook. Data subjects will therefore
      receive a faster response if they contact Facebook directly.
    </Text.p>

    <Heading3>3.2 Instagram</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      We maintain a profile on Instagram. The operator is Meta Platforms Ireland
      Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland. The
      privacy policy is available here:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://help.instagram.com/519522125107875"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Instagram privacy policy"
      >
        https://help.instagram.com/519522125107875
      </a>
      .
    </Text.p>

    <Heading3>3.3 LinkedIn</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      We maintain a profile on LinkedIn. The operator is LinkedIn Ireland
      Unlimited Company, Wilton Place, Dublin 2, Ireland. The privacy policy is
      available here:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.linkedin.com/legal/privacy-policy?_l=de_DE"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="LinkedIn privacy policy"
      >
        https://www.linkedin.com/legal/privacy-policy?_l=de_DE
      </a>
      . One way to object to data processing is via the settings for
      advertisements:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="LinkedIn retargeting opt-out"
      >
        https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
      </a>
      .
    </Text.p>

    <Heading3>3.4 Xing</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      We maintain a profile on Xing. The operator is XING AG, Dammtorstraße
      29-32, 20354 Hamburg. The privacy policy is available here:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://privacy.xing.com/de/datenschutzerklaerung"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Xing privacy policy"
      >
        https://privacy.xing.com/de/datenschutzerklaerung
      </a>
      .
    </Text.p>

    <Heading2 style={{ marginTop: '48px', fontSize: '32px' }}>
      4. Changes to this privacy policy
    </Heading2>
    <Text.p style={{ marginTop: '24px' }}>
      We reserve the right to change this privacy policy with effect for the
      future. A current version is always available here.
    </Text.p>

    <Heading2 style={{ marginTop: '48px', fontSize: '32px' }}>
      5. Questions and comments
    </Heading2>
    <Text.p style={{ marginTop: '24px' }}>
      If you have any questions or comments regarding this privacy policy,
      please feel free to contact us using the contact information provided
      above.
    </Text.p>

    <a
      href="https://heydata.eu/en/"
      target="_blank"
      title="heyData GDPR seal"
      rel="noopener noreferrer"
    >
      <img
        alt="heyData trusted logo"
        src="https://api.heydata.eu/privacy-seal/seal/81ffb4dc-1d94-49da-992d-b11fc5d0f3b0?lang=en&design=design1&sealType=GDPR"
        style={{ border: 0 }}
        width="180"
        height="180"
      />
    </a>

    <Text.pGrey style={{ marginTop: '24px' }}>
      © Neugelb Studios GmbH
    </Text.pGrey>
  </>
);

const De = () => (
  <>
    <Heading2>Datenschutzerklärung</Heading2>
    <Heading2 style={{ marginTop: '48px', fontSize: '32px' }}>
      1. Einleitung
    </Heading2>
    <Text.p>
      Im Folgenden informieren wir über die Verarbeitung personenbezogener Daten
      bei der Nutzung unserer Website www.neugelb.com und unserer Profile in
      Sozialen Medien. Personenbezogene Daten sind alle Daten, die auf eine
      konkrete natürliche Person beziehbar sind, z. B. ihr Name oder ihre
      IP-Adresse.
    </Text.p>

    <Heading3>1.1 Kontaktdaten</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Verantwortlicher gem. Art. 4 Abs. 7 EU-Datenschutz-Grundverordnung (DSGVO)
      ist:
      <br />
      NEUGELB Studios GmbH <br />
      Zeughofstraße 20, Berlin, Deutschland
      <br /> E-Mail:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="mailto:intern@neugelb.com"
        aria-label="Email Neugelb Studios"
      >
        intern@neugelb.com
      </a>
      <br />
      Gesetzlich vertreten werden wir durch Thomas Kaiser
      <br />
      Vorsitzender des Verwaltungsrats: Dominik Stöttner
    </Text.p>
    <Text.p>
      Unser Datenschutzbeauftragter ist über: <br />
      heyData GmbH
      <br />
      Schützenstraße 5, 10117 Berlin <br />
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.heydata.eu"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="heyData website"
      >
        www.heydata.eu
      </a>
      <br />
      E-Mail:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="mailto:datenschutz@heydata.eu"
        aria-label="Email data protection officer"
      >
        datenschutz@heydata.eu
      </a>{' '}
    </Text.p>

    <Heading3>
      1.2 Umfang der Datenverarbeitung, Verarbeitungszwecke und Rechtsgrundlagen
    </Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Den Umfang der Verarbeitung der Daten, Verarbeitungszwecke und
      Rechtsgrundlagen führen wir im Detail weiter unten aus. Als
      Rechtsgrundlage für eine Datenverarbeitung kommen grundsätzlich die
      folgenden in Betracht:
    </Text.p>
    <div style={{ marginLeft: '20px' }}>
      <List>
        <ListItem style={{ marginBottom: '16px' }}>
          Art. 6 Abs. 1 S. 1 lit. a DSGVO dient uns als Rechtsgrundlage für
          Verarbeitungsvorgänge, für die wir eine Einwilligung einholen.
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Art. 6 Abs. 1 S. 1 lit. b DSGVO ist Rechtsgrundlage, soweit die
          Verarbeitung personenbezogener Daten zur Erfüllung eines Vertrages
          erforderlich ist, z.B. wenn ein Seitenbesucher von uns ein Produkt
          erwirbt oder wir für ihn eine Leistung ausführen. Diese
          Rechtsgrundlage gilt auch für Verarbeitungen, die für vorvertragliche
          Maßnahmen erforderlich sind, etwa bei Anfragen zu unseren Produkten
          oder Leistungen.
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Art. 6 Abs. 1 S. 1 lit. c DSGVO findet Anwendung, wenn wir mit der
          Verarbeitung personenbezogener Daten eine rechtliche Verpflichtung
          erfüllen, wie es z.B. im Steuerrecht der Fall sein kann.
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Art. 6 Abs. 1 S. 1 lit. f DSGVO dient als Rechtsgrundlage, wenn wir
          uns zur Verarbeitung personenbezogener Daten auf berechtigte
          Interessen berufen können, z.B. für Cookies, die für den technischen
          Betrieb unserer Website erforderlich sind.
        </ListItem>
      </List>
    </div>

    <Heading3>1.3 Datenverarbeitung außerhalb des EWR</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Soweit wir Daten an Dienstleister oder sonstige Dritte außerhalb des EWR
      übermitteln, garantieren Angemessenheitsbeschlüsse der EU-Kommission nach
      Art. 45 Ab. 3 DSGVO die Sicherheit der Daten bei der Weitergabe, soweit
      diese vorhanden sind, wie dies z.B. für Großbritannien, Kanada und Israel
      der Fall ist.
    </Text.p>
    <Text.p>
      Bei der Datenweitergabe an Dienstleister in den USA, ist Rechtsgrundlage
      für die Datenweitergabe ein Angemessenheitsbeschluss der EU-Kommission,
      wenn sich der Dienstleister zusätzlich unter dem EU US Data Privacy
      Framework zertifiziert hat.
    </Text.p>
    <Text.p>
      In anderen Fällen (z.B. wenn kein Angemessenheitsbeschluss existiert),
      sind Rechtsgrundlage für die Datenweitergabe im Regelfall, also soweit wir
      keinen abweichenden Hinweis geben, Standardvertragsklauseln. Diese sind
      ein von der EU-Kommission verabschiedetes Regelwerk und Teil des Vertrags
      mit dem jeweiligen Dritten. Nach Art. 46 Abs. 2 lit. b DSGVO gewährleisten
      sie die Sicherheit der Datenweitergabe. Viele der Anbieter haben über die
      Standardvertragsklauseln hinausgehende vertragliche Garantien abgegeben,
      die die Daten über die Standardvertragsklauseln hinaus schützen. Das sind
      z.B. Garantien hinsichtlich der Verschlüsselung der Daten oder
      hinsichtlich einer Pflicht des Dritten zum Hinweis an Betroffene, wenn
      Strafverfolgungsorgane auf Daten zugreifen wollen.
    </Text.p>

    <Heading3>1.4 Speicherdauer</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Sofern nicht im Rahmen dieser Datenschutzerklärung ausdrücklich angegeben,
      werden die bei uns gespeicherten Daten gelöscht, sobald sie für ihre
      Zweckbestimmung nicht mehr erforderlich sind und der Löschung keine
      gesetzlichen Aufbewahrungspflichten entgegenstehen. Sofern die Daten nicht
      gelöscht werden, weil sie für andere und gesetzlich zulässige Zwecke
      erforderlich sind, wird ihre Verarbeitung eingeschränkt, d.h. die Daten
      werden gesperrt und nicht für andere Zwecke verarbeitet. Das gilt z.B. für
      Daten, die wir aus handels- oder steuerrechtlichen Gründen aufbewahren
      müssen.
    </Text.p>

    <Heading3>1.5 Rechte der Betroffenen</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Betroffene haben gegenüber uns folgende Rechte hinsichtlich der sie
      betreffenden personenbezogenen Daten:
    </Text.p>
    <div style={{ marginLeft: '20px' }}>
      <List>
        <ListItem style={{ marginBottom: '16px' }}>
          Recht auf Auskunft,
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Recht auf Berichtigung oder Löschung,
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Recht auf Einschränkung der Verarbeitung,
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Recht auf Widerspruch gegen die Verarbeitung,
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Recht auf Datenübertragbarkeit,
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Recht, eine erteilte Einwilligung jederzeit zu widerrufen.
        </ListItem>
      </List>
    </div>
    <Text.p>
      Betroffene haben zudem das Recht, sich bei einer
      Datenschutz-Aufsichtsbehörde über die Verarbeitung ihrer personenbezogenen
      Daten zu beschweren. Kontaktdaten der Datenschutz-Aufsichtsbehörden sind
      unter{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Data protection supervisory authorities"
      >
        https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html
      </a>{' '}
      abrufbar.
    </Text.p>

    <Heading3>1.6 Pflicht zur Bereitstellung von Daten</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Kunden, Interessenten oder Dritte müssen uns im Rahmen einer
      Geschäftsbeziehung oder sonstigen Beziehung nur diejenigen
      personenbezogenen Daten bereitstellen, die für die Begründung,
      Durchführung und Beendigung der Geschäftsbeziehung oder für die sonstige
      Beziehung erforderlich sind oder zu deren Erhebung wir gesetzlich
      verpflichtet sind. Ohne diese Daten werden wir in der Regel den Abschluss
      eines Vertrages oder die Bereitstellung einer Leistung ablehnen müssen
      oder einen bestehenden Vertrag oder sonstige Beziehung nicht mehr
      durchführen können.
    </Text.p>
    <Text.p>Pflichtangaben sind als solche gekennzeichnet.</Text.p>

    <Heading3>
      1.7 Keine automatische Entscheidungsfindung im Einzelfall
    </Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Zur Begründung und Durchführung einer Geschäftsbeziehung oder sonstigen
      Beziehung nutzen wir grundsätzlich keine vollautomatisierte
      Entscheidungsfindung gemäß Artikel 22 DSGVO. Sollten wir diese Verfahren
      in Einzelfällen einsetzen, werden wir hierüber gesondert informieren,
      sofern dies gesetzlich geboten ist.
    </Text.p>

    <Heading3>1.8 Kontaktaufnahme</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Bei der Kontaktaufnahme mit uns, z.B. per E-Mail oder Telefon, werden die
      uns mitgeteilten Daten (z.B. Namen und E-Mail-Adressen) von uns
      gespeichert, um Fragen zu beantworten. Rechtsgrundlage für die
      Verarbeitung ist unser berechtigtes Interesse (Art. 6 Abs. 1 S. 1 lit. f
      DSGVO), an uns gerichtete Anfragen zu beantworten. Die in diesem
      Zusammenhang anfallenden Daten löschen wir, nachdem die Speicherung nicht
      mehr erforderlich ist, oder schränken die Verarbeitung ein, falls
      gesetzliche Aufbewahrungspflichten bestehen.
    </Text.p>

    <Heading3>1.9 Kundenumfragen</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Von Zeit zu Zeit führen wir Kundenumfragen durch, um unsere Kunden und
      ihre Wünsche besser kennenzulernen. Dabei erheben wir die jeweils
      abgefragten Daten. Es ist unser berechtigtes Interesse, unsere Kunden und
      ihre Wünsche besser kennenzulernen, so dass Rechtsgrundlage der damit
      einhergehenden Datenverarbeitung Art. 6 Abs. 1 S. 1 lit f DSGVO ist. Die
      Daten löschen wir, wenn die Ergebnisse der Umfragen ausgewertet sind.
    </Text.p>

    <Heading2 style={{ marginTop: '48px', fontSize: '32px' }}>
      2. Datenverarbeitung auf unserer Website
    </Heading2>

    <Heading3>2.1 Hinweis für Websitebesucher aus Deutschland</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Unsere Website speichert Informationen in der Endeinrichtung von
      Websitebesuchern (z.B. Cookies) oder greift auf Informationen zu, die
      bereits in der Endeinrichtung gespeichert sind (z.B. IP-Adressen). Welche
      Informationen dies im Einzelnen sind, ist den folgenden Abschnitten zu
      entnehmen.
    </Text.p>
    <Text.p>
      Diese Speicherung und dieser Zugriff erfolgt auf Grundlage der folgenden
      Bestimmungen:
    </Text.p>
    <div style={{ marginLeft: '20px' }}>
      <List>
        <ListItem style={{ marginBottom: '16px' }}>
          Soweit diese Speicherung oder dieser Zugriff unbedingt erforderlich
          ist, damit wir dem von Websitebesuchern ausdrücklich gewünschten
          Dienst unserer Website zur Verfügung stellen (z.B. zur Durchführung
          eines vom Websitebesucher genutzten Chatbot oder zur Sicherstellung
          der IT- Sicherheit unserer Website), erfolgt sie auf Grundlage von §
          25 Abs. 2 Nr. 2 des
          Telekommunikation-Digitale-Dienste-Datenschutz-Gesetzes (TDDDG).
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Im Übrigen erfolgt diese Speicherung oder dieser Zugriff auf Grundlage
          der Einwilligung der Websitebesucher (§ 25 Abs. 1 TDDDG).
        </ListItem>
      </List>
    </div>
    <Text.p>
      Die nachgelagerte Datenverarbeitung erfolgt nach Maßgabe der folgenden
      Abschnitte und auf Grundlage der Vorschriften der DSGVO.
    </Text.p>

    <Heading3>2.2 Informatorische Nutzung der Website</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Bei der informatorischen Nutzung der Website, also wenn Seitenbesucher uns
      nicht gesondert Informationen übermitteln, erheben wir die
      personenbezogenen Daten, die der Browser an unseren Server übermittelt, um
      die Stabilität und Sicherheit unserer Website zu gewährleisten. Darin
      liegt unser berechtigtes Interesse, so dass Rechtsgrundlage Art. 6 Abs. 1
      S. 1 lit. f DSGVO ist.
    </Text.p>
    <Text.p>Diese Daten sind:</Text.p>
    <div style={{ marginLeft: '20px' }}>
      <List>
        <ListItem style={{ marginBottom: '16px' }}>IP-Adresse</ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Datum und Uhrzeit der Anfrage
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Zeitzonendifferenz zur Greenwich Mean Time (GMT)
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Inhalt der Anfrage (konkrete Seite)
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Zugriffsstatus/HTTP-Statuscode
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          jeweils übertragene Datenmenge
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Website, von der die Anfrage kommt
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>Browser</ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Betriebssystem und dessen Oberfläche
        </ListItem>
        <ListItem style={{ marginBottom: '16px' }}>
          Sprache und Version der Browsersoftware.
        </ListItem>
      </List>
    </div>
    <Text.p>
      Diese Daten werden außerdem in Logfiles gespeichert. Sie werden gelöscht,
      wenn ihre Speicherung nicht mehr erforderlich ist, spätestens nach 14
      Tagen.
    </Text.p>

    <Heading3>2.3 Webhosting und Bereitstellung der Website</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Unsere Website hostet Microsoft Azure. Anbieter ist Microsoft Ireland
      Operations Limited, One Microsoft Place, South County Business Park,
      Leopardstown, Dublin 18, D18 P521, Ireland. Der Anbieter verarbeitet dabei
      die über die Website übermittelten personenbezogenen Daten, z.B. Inhalts-,
      Nutzungs-, Meta-/Kommunikationsdaten oder Kontaktdaten, in der EU. Weitere
      Informationen finden sich in der Datenschutzerklärung des Anbieters unter{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://privacy.microsoft.com/en-gb/privacystatement"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Microsoft privacy statement"
      >
        https://privacy.microsoft.com/en-gb/privacystatement
      </a>
      .
    </Text.p>
    <Text.p>
      Es ist unser berechtigtes Interesse, eine Website zur Verfügung zu
      stellen, so dass die Rechtsgrundlage der beschriebenen Datenverarbeitung
      Art. 6 Abs. 1 S. 1 lit. f DSGVO ist.
    </Text.p>

    <Heading3>2.4 Kontaktformular</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Bei Kontaktaufnahme über das Kontaktformular auf unserer Website speichern
      wir die dort abgefragten Daten und den Inhalt der Nachricht.
      Rechtsgrundlage für die Verarbeitung ist unser berechtigtes Interesse, an
      uns gerichtete Anfragen zu beantworten. Rechtsgrundlage für die
      Verarbeitung ist deshalb Art. 6 Abs. 1 S. 1 lit. f DSGVO. Die in diesem
      Zusammenhang anfallenden Daten löschen wir, nachdem die Speicherung nicht
      mehr erforderlich ist, oder schränken die Verarbeitung ein, falls
      gesetzliche Aufbewahrungspflichten bestehen.
    </Text.p>

    <Heading3>2.5 Stellenanzeigen</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Wir veröffentlichen Stellenanzeigen auf unserer Website, auf mit der
      Website verbundenen Seiten oder auf Websites von Dritten. Hierbei nutzen
      wir das Recruiting-Tool und die Plattform der softgarden e-recruiting GmbH
      (Tauentzienstraße 14, 10789 Berlin; im Folgenden „Softgarden").
    </Text.p>
    <Text.p>
      Die Verarbeitung der im Rahmen der Bewerbung angegebenen Daten erfolgt zur
      Durchführung des Bewerbungsverfahrens. Soweit diese für unsere
      Entscheidung, ein Beschäftigungsverhältnis zu begründen, erforderlich
      sind, ist Rechtsgrundlage Art. 88 Abs. 1 DSGVO i. V. m. § 26 Abs. 1 BDSG.
      Die zur Durchführung des Bewerbungsverfahrens erforderlichen Daten haben
      wir entsprechend gekennzeichnet oder weisen auf sie hin. Wenn Bewerber
      diese Daten nicht angeben, können wir die Bewerbung nicht bearbeiten.
      Weitere Daten sind freiwillig und nicht für eine Bewerbung erforderlich.
      Falls Bewerber weitere Angaben machen, ist Grundlage ihre Einwilligung
      (Art. 6 Abs. 1 S. 1 lit. a DSGVO).
    </Text.p>
    <Text.p>
      Wir bitten Bewerber, in Lebenslauf und Anschreiben auf Angaben zu
      politischen Meinungen, religiösen Anschauungen und ähnlich sensiblen Daten
      zu verzichten. Sie sind nicht für eine Bewerbung erforderlich. Wenn
      Bewerber dennoch entsprechende Angaben machen, können wir ihre
      Verarbeitung im Rahmen der Verarbeitung des Lebenslaufes oder Anschreibens
      nicht verhindern. Ihre Verarbeitung beruht dann auch auf der Einwilligung
      der Bewerber (Art. 9 Abs. 2 lit. a DSGVO).
    </Text.p>
    <Text.p>
      Schließlich verarbeiten wir die Daten der Bewerber für weitere
      Bewerbungsverfahren, wenn sie uns dazu ihre Einwilligung erteilt haben. In
      diesem Fall ist Rechtsgrundlage Art. 6 Abs. 1 S. 1 lit. a DSGVO.
    </Text.p>
    <Text.p>
      Die Daten der Bewerber geben wir an die zuständigen Mitarbeiter der
      Personalabteilung, an die im Übrigen im Bewerbungsverfahren beteiligten
      Mitarbeiter sowie an Softgarden als unseren weisungsgebundenen
      Auftragsverarbeiter im Bereich Recruiting weiter.
    </Text.p>
    <Text.p>
      Wenn wir im Anschluss an das Bewerbungsverfahren ein
      Beschäftigungsverhältnis mit dem Bewerber eingehen, löschen wir die Daten
      erst nach Beendigung des Beschäftigungsverhältnisses. Andernfalls löschen
      wir die Daten spätestens sechs Monate nach Ablehnung eines Bewerbers.
    </Text.p>
    <Text.p>
      Wenn Bewerber uns ihre Einwilligung erteilt haben, ihre Daten auch für
      weitere Bewerbungsverfahren zu verwenden, löschen wir ihre Daten erst ein
      Jahr nach Erhalt der Bewerbung.
    </Text.p>

    <Heading3>2.6 Drittanbieter</Heading3>

    <Heading3 style={{ marginTop: '24px', fontSize: '22px' }}>
      2.6.1 Personio
    </Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Wir setzen Personio zum Recruiting ein. Der Anbieter ist Personio GmbH,
      Rundfunkplatz 4, 80335 München. Der Anbieter verarbeitet
      Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen),
      Kontaktdaten (z.B. E-Mail-Adressen, Telefonnummern), Nutzungsdaten (z.B.
      besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten) in der EU.
    </Text.p>
    <Text.p>
      Die Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.
      Wir haben ein berechtigtes Interesse, im Internet nach neuen Talenten für
      unser Team zu suchen.
    </Text.p>
    <Text.p>
      Die Daten werden gelöscht, wenn der Zweck ihrer Erhebung entfallen ist und
      keine Aufbewahrungspflicht entgegensteht. Weitere Informationen sind in
      der Datenschutzerklärung des Anbieters unter{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.personio.de/datenschutzerklaerung/"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Personio privacy policy"
      >
        https://www.personio.de/datenschutzerklaerung/
      </a>{' '}
      abrufbar.
    </Text.p>

    <Heading3 style={{ marginTop: '24px', fontSize: '22px' }}>
      2.6.2 heyData
    </Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Wir haben ein Datenschutz-Siegel auf unserer Website eingebunden. Der
      Anbieter ist heyData GmbH, Schützenstraße 5, 10117 Berlin, Deutschland.
      Der Anbieter verarbeitet Meta-/Kommunikationsdaten (z.B. IP-Adressen) in
      der EU.
    </Text.p>
    <Text.p>
      Die Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.
      Wir haben ein berechtigtes Interesse, Website-Besuchern eine Bestätigung
      über unsere Datenschutz-Compliance zur Verfügung zu stellen. Gleichzeitig
      hat der Anbieter ein berechtigtes Interesse daran, sicherzustellen, dass
      nur Kunden mit bestehenden Verträgen seine Siegel nutzen, weshalb eine
      bloße Bildkopie des Zertifikats keine gangbare Alternative zur Bestätigung
      darstellt.
    </Text.p>
    <Text.p>
      Die Daten werden nach der Erhebung maskiert, damit kein Personenbezug mehr
      besteht. Weitere Informationen sind in der Datenschutzerklärung des
      Anbieters unter{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://heydata.eu/en/privacy-policy"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="heyData privacy policy"
      >
        https://heydata.eu/en/privacy-policy
      </a>{' '}
      abrufbar.
    </Text.p>

    <Heading2 style={{ marginTop: '48px', fontSize: '32px' }}>
      3. Datenverarbeitung auf Social Media-Plattformen
    </Heading2>
    <Text.p style={{ marginTop: '24px' }}>
      Wir sind in Social Media-Netzwerken vertreten, um dort unsere Organisation
      und unsere Leistungen vorzustellen. Die Betreiber dieser Netzwerke
      verarbeiten Daten ihrer Nutzer regelmäßig zu Werbezwecken. Unter anderem
      erstellen sie aus ihrem Onlineverhalten Nutzerprofile, die beispielsweise
      dazu verwendet werden, um auf den Seiten der Netzwerke und auch sonst im
      Internet Werbung zu zeigen, die den Interessen der Nutzer entspricht. Dazu
      speichern die Betreiber der Netzwerke Informationen zu dem
      Nutzungsverhalten in Cookies auf dem Rechner der Nutzer. Es ist außerdem
      nicht auszuschließen, dass die Betreiber diese Informationen mit weiteren
      Daten zusammenführen. Weitere Informationen sowie Hinweise, wie Nutzer der
      Verarbeitung durch die Seitenbetreiber widersprechen können, erhalten
      Nutzer in den unten aufgeführten Datenschutzerklärungen der jeweiligen
      Betreiber. Es kann auch sein, dass die Betreiber oder ihre Server in
      Nicht-EU-Staaten sitzen, so dass sie Daten dort verarbeiten. Hierdurch
      können sich für die Nutzer Risiken ergeben, z.B. weil die Durchsetzung
      ihrer Rechte erschwert wird oder staatliche Stellen Zugriff auf die Daten
      nehmen.
    </Text.p>
    <Text.p>
      Wenn Nutzer der Netzwerke mit uns über unsere Profile in Kontakt treten,
      verarbeiten wir die uns mitgeteilten Daten, um die Anfragen zu
      beantworten. Darin liegt unser berechtigtes Interesse, so dass
      Rechtsgrundlage Art. 6 Abs. 1 S. 1 lit. f DSGVO ist.
    </Text.p>

    <Heading3>3.1 Facebook</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Wir unterhalten ein Profil auf Facebook. Betreiber ist Meta Platforms
      Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.
      Die Datenschutzerklärung ist hier abrufbar:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.facebook.com/policy.php"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Facebook privacy policy"
      >
        https://www.facebook.com/policy.php
      </a>
      . Eine Möglichkeit, der Datenverarbeitung zu widersprechen, ergibt sich
      über Einstellungen für Werbeanzeigen:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.facebook.com/settings?tab=ads"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Facebook advertisement settings"
      >
        https://www.facebook.com/settings?tab=ads
      </a>
      .
    </Text.p>
    <Text.p>
      Wir sind auf Grundlage einer Vereinbarung gemeinsam im Sinne von Art. 26
      DSGVO mit Facebook für die Verarbeitung der Daten der Besucher unseres
      Profils verantwortlich. Welche Daten genau verarbeitet werden, erklärt
      Facebook unter{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.facebook.com/legal/terms/information_about_page_insights_data"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Facebook page insights data information"
      >
        https://www.facebook.com/legal/terms/information_about_page_insights_data
      </a>
      . Betroffene können ihre Rechte sowohl gegenüber uns als auch gegenüber
      Facebook wahrnehmen. Nach unserer Vereinbarung mit Facebook sind wir aber
      dazu verpflichtet, Anfragen an Facebook weiterzuleiten. Betroffene
      erhalten also eine schnellere Rückmeldung, wenn sie sich direkt an
      Facebook wenden.
    </Text.p>

    <Heading3>3.2 Instagram</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Wir unterhalten ein Profil auf Instagram. Betreiber ist Meta Platforms
      Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.
      Die Datenschutzerklärung ist hier abrufbar:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://help.instagram.com/519522125107875"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Instagram privacy policy"
      >
        https://help.instagram.com/519522125107875
      </a>
      .
    </Text.p>

    <Heading3>3.3 LinkedIn</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Wir unterhalten ein Profil auf LinkedIn. Betreiber ist LinkedIn Ireland
      Unlimited Company, Wilton Place, Dublin 2, Irland. Die
      Datenschutzerklärung ist hier abrufbar:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.linkedin.com/legal/privacy-policy?_l=de_DE"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="LinkedIn privacy policy"
      >
        https://www.linkedin.com/legal/privacy-policy?_l=de_DE
      </a>
      . Eine Möglichkeit, der Datenverarbeitung zu widersprechen, ergibt sich
      über die Einstellungen für Werbeanzeigen:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="LinkedIn retargeting opt-out"
      >
        https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
      </a>
      .
    </Text.p>

    <Heading3>3.4 Xing</Heading3>
    <Text.p style={{ marginTop: '24px' }}>
      Wir unterhalten ein Profil auf Xing. Betreiber ist New Work SE,
      Dammtorstraße 29-32, 20354 Hamburg. Die Datenschutzerklärung ist hier
      abrufbar:{' '}
      <a
        style={{ textDecoration: 'underline' }}
        href="https://privacy.xing.com/de/datenschutzerklaerung"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Xing privacy policy"
      >
        https://privacy.xing.com/de/datenschutzerklaerung
      </a>
      .
    </Text.p>

    <Heading2 style={{ marginTop: '48px', fontSize: '32px' }}>
      4. Änderungen dieser Datenschutzerklärung
    </Heading2>
    <Text.p style={{ marginTop: '24px' }}>
      Wir behalten uns das Recht vor, diese Datenschutzerklärung mit Wirkung für
      die Zukunft zu ändern. Eine aktuelle Version ist jeweils hier verfügbar.
    </Text.p>

    <Heading2 style={{ marginTop: '48px', fontSize: '32px' }}>
      5. Fragen und Kommentare
    </Heading2>
    <Text.p style={{ marginTop: '24px' }}>
      Für Fragen oder Kommentare bezüglich dieser Datenschutzerklärung stehen
      wir gern unter den oben angegebenen Kontaktdaten zur Verfügung.
    </Text.p>

    <a
      href="https://heydata.eu/"
      target="_blank"
      title="heyData GDPR seal"
      rel="noopener noreferrer"
    >
      <img
        alt="heyData trusted logo"
        src="https://api.heydata.eu/privacy-seal/seal/81ffb4dc-1d94-49da-992d-b11fc5d0f3b0?lang=de&design=design1&sealType=GDPR"
        style={{ border: 0 }}
        width="180"
        height="180"
      />
    </a>

    <Text.pGrey style={{ marginTop: '24px' }}>
      © Neugelb Studios GmbH
    </Text.pGrey>
  </>
);

export default DataProtection;
